import React, { useState, useEffect } from "react";
import API_DOMAIN from "../config/config";
import {
  Container,
  Row,
  Col,
  Table,
  Button,
  Modal,
  Tab,
  Tabs,
} from "react-bootstrap";
import {
  Calender,
  DropDown,
  InstantModel,
  TextInputForm,
  DropDownUI,
} from "../components/Forms";
import { PageHead } from "../components/PageTitle";
import { MdOutlineDeleteOutline } from "react-icons/md";
import { useNavigate, Navigate, useLocation } from "react-router-dom";
import {
  Buttons,
  Dltbtn,
  InstantCreate,
  ClickButton,
  Delete,
} from "../components/Buttons";
import PayMents from "../components/PayMents";
import { BiPlus } from "react-icons/bi";
import { ValueContainer } from "react-select/animated";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { MdDeleteForever } from "react-icons/md";
import moment from "moment/moment";
import companyId from "../config/companyId";

const DOMAIN = "https://kalaicrackers.zentexus.in/api";

const EstimationEntry = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { type, rowData } = location.state || {};
  const [showModal, setShowModal] = useState(false);
  const [toggled, setToggled] = useState(false);
  const [tax_type, settax_type] = useState("");
  const [discountType, setDiscountType] = useState(
    rowData?.discount_type || "Discount %"
  );

  const handleClick = () => {
    setToggled(!toggled);
  };

  const getTaxLabel = (taxType, taxPercentage) => {
    const percentage = parseFloat(taxPercentage) || 0;
    return `${taxType}@${percentage}%`;
  };

  const initialState =
    type === "edit"
      ? {
          ...rowData,
          discount:
            rowData.discount !== undefined ? rowData.discount.toString() : "0",
          discount_type: rowData.discount_type || "Discount %",
          packing_percentage: rowData.packing_percentage || "",
          packing_amount: rowData.packing_amount || "0",
          subtotal: rowData.sub_total || "0",
          balance_amount: rowData.balance || "0",
          total: (
            parseFloat(rowData.sub_total || 0) -
            (rowData.discount_type === "Discount Amount"
              ? parseFloat(rowData.discount || 0)
              : (parseFloat(rowData.sub_total || 0) *
                  parseFloat(rowData.discount || 0)) /
                100) +
            (parseFloat(rowData.sub_total || 0) -
              (rowData.discount_type === "Discount Amount"
                ? parseFloat(rowData.discount || 0)
                : (parseFloat(rowData.sub_total || 0) *
                    parseFloat(rowData.discount || 0)) /
                  100)) *
              (parseFloat(rowData.packing_percentage || 0) / 100)
          ).toFixed(2),
          product: rowData.product.map((product) => ({
            ...product,
            tax_label: getTaxLabel(product.tax_type, product.tax_percentage),
          })),
          payment_method: Array.isArray(rowData.payment_method)
            ? rowData.payment_method
            : typeof rowData.payment_method === "string"
            ? JSON.parse(rowData.payment_method || "[]")
            : [],
          bill_date:
            rowData.bill_date && moment(rowData.bill_date).isValid()
              ? moment(rowData.bill_date).format("YYYY-MM-DD")
              : moment().format("YYYY-MM-DD"),
        }
      : {
          party_name: "",
          eway_no: "",
          vechile_no: "",
          bill_date: moment().format("YYYY-MM-DD"),
          state_of_supply: "",
          mobile_number: "",
          address: "",
          total: "0",
          subtotal: "0",
          paid: "0",
          balance_amount: "0",
          final_total: "0",
          discount: "0",
          discount_type: "Discount %",
          packing_percentage: "",
          packing_amount: "0",
          total_discountall: "0",
          taxover_amt: "0",
          taxover_percentage: "0",
          round_off_checkbox: "",
          remark: "",
          payment_method: [],
          product: [
            {
              product_id: "",
              qty: "",
              unit: "",
              price_unit: "",
              discount_percentage: "",
              discount_amt: "",
              tax_type: "",
              tax_percentage: "",
              tax_amt: "",
              CGST: "",
              SGST: "",
              IGST: "",
              total_amt: "",
              tax_label: "GST@0%",
            },
          ],
        };

  const [formData, setFormData] = useState(initialState);
  const [formDataPartySales, setformDataPartySales] = useState({
    party_name: "",
    mobile_number: "",
    alter_number: "",
    email: "",
    company_name: "",
    gst_no: "",
    address: "",
    opening_balance: "",
    opening_date: "",
    ac_type: "",
  });
  const [paymentDetails, setPaymentDetails] = useState([]);
  const [newPayment, setNewPayment] = useState({
    payment_method: "",
    amount: "",
    balance: "",
  });
  const [loading, setLoading] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [productData, setProductData] = useState([]);
  const [UnitData, setUnitData] = useState([]);

  useEffect(() => {
    if (type === "edit" && rowData?.payment_method) {
      try {
        const parsedPayments = Array.isArray(rowData.payment_method)
          ? rowData.payment_method
          : JSON.parse(rowData.payment_method || "[]");
        setPaymentDetails(parsedPayments || []);
      } catch (error) {
        console.error("Error parsing payment_method:", error);
        setPaymentDetails([]);
      }
    }

    setDiscountType(formData.discount_type || "Discount %");
  }, [type, rowData]);

  const setLabel = (value, field) => {
    if (!value || !moment(value).isValid()) {
      console.error("Invalid date received in setLabel:", value);
      return;
    }
    setFormData({
      ...formData,
      [field]: moment(value).format("YYYY-MM-DD"),
    });
  };

  const setLabell = (value, field) => {
    setformDataPartySales({
      ...formDataPartySales,
      [field]: moment(value).format("YYYY-MM-DD"),
    });
  };

  const handleAddPayment = () => {
    const totalPaymentAmount = paymentDetails.reduce(
      (total, payment) => total + (parseFloat(payment.amount) || 0),
      0
    );
    const balance = parseFloat(formData.total) || 0;

    if (newPayment.payment_method && newPayment.amount) {
      if (totalPaymentAmount + parseFloat(newPayment.amount) > balance) {
        alert(
          "Insufficient balance. The total payment amount exceeds the available balance."
        );
      } else {
        const updatedPayment = {
          ...newPayment,
          balance: (
            balance -
            (totalPaymentAmount + parseFloat(newPayment.amount))
          ).toFixed(2),
        };
        setPaymentDetails((prev) => [...prev, updatedPayment]);
        setNewPayment({ payment_method: "", amount: "", balance: "" });
      }
    } else {
      alert("Please select a payment method and enter an amount.");
    }
  };

  useEffect(() => {
    const fetchProductData = async () => {
      try {
        const response = await fetch(`${DOMAIN}/products.php?id=${companyId}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            search_text: "",
          }),
        });

        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }

        const responseData = await response.json();
        setLoading(false);

        if (responseData.status === 200 && Array.isArray(responseData.data)) {
          const validData = responseData.data.filter(
            (item) => item && typeof item.product_name === "string"
          );
          setProductData(validData);
        } else {
          throw new Error(responseData.msg);
        }
      } catch (error) {
        setLoading(false);
        console.error("Error fetching data:", error.message);
      }
    };

    fetchProductData();
  }, []);

  const fetchUnitData = async () => {
    try {
      const response = await fetch(`${API_DOMAIN}/unit.php?id=${companyId}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          search_text: "",
        }),
      });
      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }

      const responseData = await response.json();

      if (responseData.status === 200) {
        setUnitData(responseData.data);
      } else {
        throw new Error(responseData.msg);
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUnitData();
  }, []);

  const errorAlert = (input) => {
    toast.error(input, {
      position: "top-center",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
  };

  const successAlert = (success) => {
    toast.success(success, {
      position: "top-center",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
  };

  const calculatePackingAmount = (
    subtotal,
    discount,
    discountType,
    packingPercentage
  ) => {
    const subtotalValue = parseFloat(subtotal) || 0;
    const discountValue = parseFloat(discount) || 0;
    const packingPercentageValue = parseFloat(packingPercentage) || 0;

    const discountAmount =
      discountType === "Discount %"
        ? ((subtotalValue * discountValue) / 100).toFixed(2)
        : discountValue.toFixed(2);
    const discountedSubtotal =
      discountType === "Discount %"
        ? (subtotalValue - (subtotalValue * discountValue) / 100).toFixed(2)
        : (subtotalValue - discountValue).toFixed(2);
    const packingAmount = (discountedSubtotal * packingPercentageValue) / 100;
    return packingAmount.toFixed(2);
  };

  const handleSubmit = async () => {
    try {
      const subtotal = parseFloat(formData.subtotal) || 0;
      const discount = parseFloat(formData.discount) || 0;
      const packingPercentage = parseFloat(formData.packing_percentage) || 0;

      const discountAmount =
        discountType === "Discount %"
          ? ((subtotal * discount) / 100).toFixed(2)
          : discount.toFixed(2);
      const discountedSubtotal =
        discountType === "Discount %"
          ? (subtotal - (subtotal * discount) / 100).toFixed(2)
          : (subtotal - discount).toFixed(2);
      const packingAmount = calculatePackingAmount(
        subtotal,
        discount,
        discountType,
        packingPercentage
      );
      const total = (
        parseFloat(discountedSubtotal) + parseFloat(packingAmount)
      ).toFixed(2);

      const sanitizedFormData = {
        ...formData,
        payment_method: paymentDetails,
        discount_type: discountType,
        discount_amount: discountAmount,
        packing_percentage: packingPercentage.toString(),
        packing_amount: packingAmount,
        product: formData.product.map((product) => ({
          ...product,
          tax_amt: product.tax_amt || "0",
          tax_percentage: product.tax_percentage || "0",
          CGST: product.CGST || "0",
          SGST: product.SGST || "0",
          IGST: product.IGST || "0",
          without_tax_amount: (
            (parseFloat(product.qty) || 0) *
              (parseFloat(product.price_unit) || 0) -
            (parseFloat(product.discount_amt) || 0)
          ).toFixed(2),
        })),
        sub_total: subtotal.toFixed(2),
        discount: discount.toFixed(2),
        balance: total,
        total: total,
        sum_total: formData.product
          .reduce(
            (acc, row) =>
              acc +
              ((parseFloat(row.qty) || 0) * (parseFloat(row.price_unit) || 0) -
                (parseFloat(row.discount_amt) || 0)),
            0
          )
          .toFixed(2),
      };
      console.log("submission data", sanitizedFormData);
      const response = await fetch(
        `${API_DOMAIN}/sales_estimation.php?id=${companyId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(sanitizedFormData),
        }
      );

      const responseData = await response.json();
      console.log("responseData", responseData);

      if (responseData.status === 200) {
        setFormData(initialState);
        setPaymentDetails([]);
        successAlert(responseData.msg);
        setTimeout(() => {
          navigate("/console/sales/estimation");
        }, 2000);
      } else {
        handleErrors(responseData);
      }
    } catch (error) {
      console.error("Error during submission:", error.message);
      errorAlert(error.message);
    }
  };

  const handleErrors = (responseData) => {
    if (responseData.status === 400) {
      toast.error(responseData.msg, {
        position: "top-center",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } else {
      setShowAlert(true);
    }
  };

  const handleUpdateSubmit = async () => {
    try {
      setLoading(true);

      const sum_total = formData.product
        .reduce(
          (acc, row) =>
            acc +
            ((parseFloat(row.qty) || 0) * (parseFloat(row.price_unit) || 0) -
              (parseFloat(row.discount_amt) || 0)),
          0
        )
        .toFixed(2);

      const subtotal = parseFloat(formData.subtotal) || 0;
      const discount = parseFloat(formData.discount) || 0;
      const packingPercentage = parseFloat(formData.packing_percentage) || 0;

      const discountAmount =
        discountType === "Discount %"
          ? ((subtotal * discount) / 100).toFixed(2)
          : discount.toFixed(2);
      const discountedSubtotal =
        discountType === "Discount %"
          ? (subtotal - (subtotal * discount) / 100).toFixed(2)
          : (subtotal - discount).toFixed(2);
      const packingAmount = calculatePackingAmount(
        subtotal,
        discount,
        discountType,
        packingPercentage
      );
      const total = (
        parseFloat(discountedSubtotal) + parseFloat(packingAmount)
      ).toFixed(2);

      const paid = paymentDetails
        .reduce((acc, pm) => acc + (parseFloat(pm.amount) || 0), 0)
        .toFixed(2);

      const balance = (parseFloat(total) - parseFloat(paid)).toFixed(2);

      const requestBody = {
        ...formData,
        payment_method: paymentDetails,
        discount_type: discountType,
        discount_amount: discountAmount,
        packing_percentage: packingPercentage.toString(),
        packing_amount: packingAmount,
        product: formData.product.map((product) => ({
          ...product,
          tax_amt: product.tax_amt || "0",
          tax_percentage: product.tax_percentage || "0",
          CGST: product.CGST || "0",
          SGST: product.SGST || "0",
          IGST: product.IGST || "0",
          without_tax_amount: (
            (parseFloat(product.qty) || 0) *
              (parseFloat(product.price_unit) || 0) -
            (parseFloat(product.discount_amt) || 0)
          ).toFixed(2),
        })),
        sales_estimation_id: rowData.sales_estimation_id,
        sub_total: subtotal.toFixed(2),
        discount: discount.toFixed(2),
        total: total,
        sum_total: sum_total,
        paid: paid,
        balance: balance,
      };

      const response = await fetch(
        `${API_DOMAIN}/sales_estimation.php?id=${companyId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        }
      );

      const responseData = await response.json();
      console.log(responseData);
      if (responseData.status === 200) {
        toast.success("Sales Estimation updated successfully!", {
          position: "top-center",
          autoClose: 2000,
          theme: "colored",
        });
        setTimeout(() => {
          navigate("/console/sales/estimation");
        }, 2000);
      } else {
        toast.error(responseData.msg || "Failed to update estimation", {
          position: "top-center",
          autoClose: 2000,
          theme: "colored",
        });
      }
    } catch (error) {
      console.error("Error updating estimation:", error.message);
      toast.error("Error updating estimation: " + error.message, {
        position: "top-center",
        autoClose: 2000,
        theme: "colored",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleAddRow = () => {
    setFormData((prevState) => ({
      ...prevState,
      product: [
        ...prevState.product,
        {
          product_id: "",
          qty: "",
          unit: "",
          price_unit: "",
          discount_percentage: "",
          discount_amt: "",
          tax_type: "",
          tax_percentage: "",
          tax_amt: "",
          CGST: "",
          SGST: "",
          IGST: "",
          total_amt: "",
          tax_label: "GST@0%",
        },
      ],
    }));
  };

  const handleDeleteRow = (index) => {
    setFormData((prevState) => ({
      ...prevState,
      product: prevState.product.filter((_, i) => i !== index),
    }));
  };

  const handleChangePartySales = (e, fieldName) => {
    const value = e.target ? e.target.value : e.value;

    setformDataPartySales({
      ...formDataPartySales,
      [fieldName]: value,
    });
  };

  const handlePaidChange = (e) => {
    const value = parseFloat(e.target.value) || 0;

    setFormData((prevFormData) => ({
      ...prevFormData,
      paid: value,
    }));
  };

  const handleDiscountChange = (e) => {
    const { value } = e.target;
    const discountValue = parseFloat(value) || 0;
    const subtotalValue = parseFloat(formData.subtotal) || 0;
    const packingPercentage = parseFloat(formData.packing_percentage) || 0;

    const discountAmount =
      discountType === "Discount %"
        ? ((subtotalValue * discountValue) / 100).toFixed(2)
        : discountValue.toFixed(2);
    const discountedSubtotal =
      discountType === "Discount %"
        ? (subtotalValue - (subtotalValue * discountValue) / 100).toFixed(2)
        : (subtotalValue - discountValue).toFixed(2);
    const packingAmount = calculatePackingAmount(
      subtotalValue,
      discountValue,
      discountType,
      packingPercentage
    );
    const newTotal = (
      parseFloat(discountedSubtotal) + parseFloat(packingAmount)
    ).toFixed(2);

    setFormData((prevData) => ({
      ...prevData,
      discount: value,
      discount_amount: discountAmount,
      packing_amount: packingAmount,
      total: newTotal,
    }));
  };

  const handleKeyPress = (event, index) => {
    if (event.key === "Enter") {
      const lastRow = formData.product[formData.product.length - 1];
      if (
        lastRow.product_id &&
        lastRow.qty &&
        lastRow.unit &&
        lastRow.price_unit &&
        lastRow.total_amt
      ) {
        handleAddRow();
      } else {
        toast.error(
          "Please fill in all fields in the last row before adding a new row"
        );
      }
    }
  };

  const handleRemarkChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleChange = (e, fieldName, rowIndex) => {
    const value = e.target ? e.target.value : e.value;
    let updatedFormData = { ...formData };

    if (rowIndex !== undefined) {
      updatedFormData = {
        ...formData,
        product: formData.product.map((row, index) => {
          if (index === rowIndex) {
            const updatedRow = { ...row, [fieldName]: value };

            // Recalculate row values
            const qty = parseFloat(updatedRow.qty) || 0;
            const price = parseFloat(updatedRow.price_unit) || 0;
            const discountPercentage =
              parseFloat(updatedRow.discount_percentage) || 0;
            const discountInputAmount =
              parseFloat(updatedRow.discount_amt) || 0;
            const taxPercentage = parseFloat(updatedRow.tax_percentage) || 0;
            const taxType = updatedRow.tax_type || "GST";

            // Calculate subtotal for the row
            let subtotal = qty * price;

            // Calculate discount
            let crtdiscountFiled = 0;
            if (fieldName === "discount_percentage") {
              crtdiscountFiled = (subtotal * discountPercentage) / 100;
              updatedRow.discount_amt = crtdiscountFiled.toFixed(2);
            } else if (fieldName === "discount_amt") {
              crtdiscountFiled = discountInputAmount;
              const cal = (crtdiscountFiled / subtotal) * 100;
              updatedRow.discount_percentage = isNaN(cal) ? 0 : cal.toFixed(2);
            } else {
              crtdiscountFiled = (subtotal * discountPercentage) / 100;
              updatedRow.discount_amt = crtdiscountFiled.toFixed(2);
            }

            // Calculate tax
            let tmpsubtotal = subtotal - crtdiscountFiled;
            let taxAmount = (tmpsubtotal * taxPercentage) / 100;
            let finalAmount = tmpsubtotal + taxAmount;

            let sgst = 0,
              cgst = 0,
              igst = 0;
            if (taxType === "IGST") {
              igst = taxAmount;
            } else {
              let gstamount = taxAmount / 2;
              cgst = gstamount;
              sgst = gstamount;
            }

            updatedRow.SGST = sgst.toFixed(2);
            updatedRow.CGST = cgst.toFixed(2);
            updatedRow.IGST = igst.toFixed(2);
            updatedRow.tax_amt = taxAmount.toFixed(2);
            updatedRow.total_amt = finalAmount.toFixed(2);
            updatedRow.tax_label = getTaxLabel(taxType, taxPercentage);

            return updatedRow;
          }
          return row;
        }),
      };
    } else {
      updatedFormData = {
        ...formData,
        [fieldName]: value,
      };

      // Recalculate total if packing_percentage changes
      if (fieldName === "packing_percentage") {
        const subtotalValue = parseFloat(formData.subtotal) || 0;
        const discountValue = parseFloat(formData.discount) || 0;
        const packingPercentage = parseFloat(value) || 0;

        const discountAmount =
          discountType === "Discount %"
            ? ((subtotalValue * discountValue) / 100).toFixed(2)
            : discountValue.toFixed(2);
        const discountedSubtotal =
          discountType === "Discount %"
            ? (subtotalValue - (subtotalValue * discountValue) / 100).toFixed(2)
            : (subtotalValue - discountValue).toFixed(2);
        const packingAmount = calculatePackingAmount(
          subtotalValue,
          discountValue,
          discountType,
          packingPercentage
        );
        const newTotal = (
          parseFloat(discountedSubtotal) + parseFloat(packingAmount)
        ).toFixed(2);

        updatedFormData.discount_amount = discountAmount;
        updatedFormData.packing_amount = packingAmount;
        updatedFormData.total = newTotal;
      }
    }

    // Recalculate subtotal and total
    const totalAmount = updatedFormData.product.reduce(
      (acc, row) => acc + (parseFloat(row.total_amt) || 0),
      0
    );
    const discountValue = parseFloat(updatedFormData.discount) || 0;
    const packingPercentage =
      parseFloat(updatedFormData.packing_percentage) || 0;

    const discountAmount =
      discountType === "Discount %"
        ? ((totalAmount * discountValue) / 100).toFixed(2)
        : discountValue.toFixed(2);
    const discountedSubtotal =
      discountType === "Discount %"
        ? (totalAmount - (totalAmount * discountValue) / 100).toFixed(2)
        : (totalAmount - discountValue).toFixed(2);
    const packingAmount = calculatePackingAmount(
      totalAmount,
      discountValue,
      discountType,
      packingPercentage
    );
    const newTotal = (
      parseFloat(discountedSubtotal) + parseFloat(packingAmount)
    ).toFixed(2);

    updatedFormData.subtotal = totalAmount.toFixed(2);
    updatedFormData.discount_amount = discountAmount;
    updatedFormData.packing_amount = packingAmount;
    updatedFormData.total = newTotal;

    setFormData(updatedFormData);
  };

  function calculateTax(product, tax_percentage, index, taxType) {
    let updatedFormData = { ...formData };
    let sgst = 0,
      cgst = 0,
      igst = 0;

    const productTotal = parseFloat(product.total_amt) || 0;
    const taxRate = parseFloat(tax_percentage.match(/\d+\.*\d*/)?.[0]) || 0;
    const taxAmount = productTotal - productTotal / (1 + taxRate / 100);

    if (taxType === "GST") {
      const gstAmount = taxAmount / 2;
      sgst = gstAmount;
      cgst = gstAmount;
    } else if (taxType === "IGST") {
      igst = taxAmount;
    }

    updatedFormData.product[index].SGST = sgst.toFixed(2);
    updatedFormData.product[index].CGST = cgst.toFixed(2);
    updatedFormData.product[index].IGST = igst.toFixed(2);
    updatedFormData.product[index].tax_amt = taxAmount.toFixed(2);
    updatedFormData.product[index].tax_type = taxType;
    updatedFormData.product[index].tax_label = getTaxLabel(taxType, taxRate);

    setFormData(updatedFormData);
  }

  useEffect(() => {
    const updateBalance = () => {
      const total = parseFloat(formData.total) || 0;
      const paidAmount = paymentDetails.reduce(
        (acc, pm) => acc + (parseFloat(pm.amount) || 0),
        0
      );
      const balance = total - paidAmount;

      setFormData((prevFormData) => ({
        ...prevFormData,
        balance_amount: balance.toFixed(2),
        paid: paidAmount.toFixed(2),
      }));
    };

    updateBalance();
  }, [formData.total, paymentDetails]);

  const [isLoggedIn, setIsLoggedIn] = useState(true);
  useEffect(() => {
    const checkSession = async () => {
      try {
        const session = localStorage.getItem("session");
        if (!session) {
          setIsLoggedIn(false);
        }
      } catch (error) {
        console.error("Error checking session:", error.message);
        setIsLoggedIn(false);
      }
    };
    checkSession();
  }, []);

  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  const discountOptions = [
    { value: "Discount %", label: "Discount %" },
    { value: "Discount Amount", label: "Discount Amount" },
  ];

  return (
    <>
      <div className="main" style={{ cursor: "pointer" }}>
        <Container fluid className="px-0">
          <Row>
            <Col lg="12" className="py-3">
              <PageHead
                pagehead={<>Sales Estimation</>}
                onClick={() => navigate(-1)}
              />
            </Col>
            <Col lg="12" className="py-3">
              <Table>
                <tr>
                  <td>
                    <div className="party-on">
                      <Container>
                        <Row>
                          <Col lg="4" className="py-3">
                            <div className="d-flex">
                              <div className="w-250">
                                <TextInputForm
                                  placeholder={"Party Name"}
                                  labelname={"Party Name"}
                                  name="party_name"
                                  value={formData.party_name}
                                  onChange={(e) =>
                                    handleChange(e, "party_name")
                                  }
                                />
                              </div>
                            </div>
                          </Col>
                          <Col lg="4" className="py-3">
                            <div className="w-50">
                              <TextInputForm
                                placeholder={"Mobile Number"}
                                labelname={"Mobile Number"}
                                name="mobile_number"
                                value={formData.mobile_number}
                                onChange={(e) =>
                                  handleChange(e, "mobile_number")
                                }
                              />
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg="4" className="py-3">
                            <label className="pb-2">Address</label>
                            <textarea
                              className="form-cntrl form-control"
                              placeholder={"Address"}
                              labelname={"Address"}
                              name="address"
                              value={formData.address}
                              onChange={(e) => handleChange(e, "address")}
                            />
                          </Col>
                        </Row>
                      </Container>
                    </div>
                  </td>
                  <td className="mx-auto float-end">
                    <div>
                      <Calender
                        setLabel={(date) => setLabel(date, "bill_date")}
                        initialDate={
                          formData.bill_date &&
                          moment(formData.bill_date).isValid()
                            ? moment(formData.bill_date).toDate()
                            : new Date()
                        }
                        calenderlabel="Bill Date"
                      />
                    </div>
                  </td>
                </tr>
              </Table>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="main my-3">
        <div>
          <Container fluid className="px-0">
            <Row>
              <Col lg="12" className="py-3">
                <div>
                  No Of Products: <span>{formData.product.length}</span>
                </div>
              </Col>
              <Col lg="12" md="6" xs="12">
                <div className="py-2 category-table bill">
                  <Table>
                    <thead className="">
                      <tr>
                        <th rowSpan={2} className="wrdbrk w-10">
                          #
                        </th>
                        <th rowSpan={2} className="wrdbrk w-20">
                          Product Name
                        </th>
                        <th rowSpan={2} className="wrdbrk w-10">
                          Qty
                        </th>
                        <th rowSpan={2} className="wrdbrk w-10">
                          Unit
                        </th>
                        <th rowSpan={2} className="wrdbrk w-10">
                          Price / Unit
                        </th>
                        <th rowSpan={2} className="wrdbrk w-10">
                          Amount
                        </th>
                        <th rowSpan={2} className="wrdbrk w-10"></th>
                      </tr>
                    </thead>
                    <tbody>
                      {formData.product &&
                        formData.product.map((row, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>
                              <div>
                                <DropDownUI
                                  optionlist={productData.map((user) => ({
                                    value: user.product_id,
                                    label: user.product_name,
                                  }))}
                                  placeholder="ProductName"
                                  name="product_id"
                                  value={row.product_id}
                                  onChange={(updatedFormData) => {
                                    const selectedProduct = productData.find(
                                      (user) =>
                                        user.product_id ===
                                        updatedFormData.product_id
                                    );
                                    const unitRate =
                                      Number(selectedProduct.unit_rate) || 0;
                                    const discountPct = Number(
                                      selectedProduct.discount
                                    );
                                    const hasDiscount =
                                      Number.isFinite(discountPct) &&
                                      discountPct > 0;

                                    const discountAmt = hasDiscount
                                      ? (unitRate * discountPct) / 100
                                      : 0;
                                    const perPrice = Math.max(
                                      unitRate - discountAmt,
                                      0
                                    );
                                    const taxLabel = selectedProduct
                                      ? `GST@${selectedProduct.item_gst}%`
                                      : "GST@0%";

                                    setFormData((prevFormData) => {
                                      const updatedProducts =
                                        prevFormData.product.map((r, i) => {
                                          if (i === index) {
                                            const qty = parseFloat(r.qty) || 0;
                                            const subtotal = qty * perPrice;
                                            const taxPercentage =
                                              parseFloat(
                                                selectedProduct.item_gst
                                              ) || 0;
                                            const taxType = "GST";
                                            const discountPercentage =
                                              parseFloat(
                                                r.discount_percentage
                                              ) || 0;

                                            let crtdiscountFiled =
                                              (subtotal * discountPercentage) /
                                              100;
                                            let tmpsubtotal =
                                              subtotal - crtdiscountFiled;
                                            let taxAmount =
                                              (tmpsubtotal * taxPercentage) /
                                              100;
                                            let finalAmount =
                                              tmpsubtotal + taxAmount;

                                            let sgst = 0,
                                              cgst = 0,
                                              igst = 0;
                                            if (taxType === "IGST") {
                                              igst = taxAmount;
                                            } else {
                                              let gstamount = taxAmount / 2;
                                              cgst = gstamount;
                                              sgst = gstamount;
                                            }

                                            return {
                                              ...r,
                                              product_id:
                                                updatedFormData.product_id,
                                              price_unit: perPrice.toFixed(2),
                                              tax_type: taxType,
                                              tax_percentage: selectedProduct
                                                ? selectedProduct.item_gst
                                                : 0,
                                              product_name: selectedProduct
                                                ? selectedProduct.product_name
                                                : "",
                                              product_code: selectedProduct
                                                ? selectedProduct.product_code
                                                : "",
                                              unit: selectedProduct
                                                ? selectedProduct.unit_id
                                                : "",
                                              tax_label: taxLabel,
                                              discount_amt:
                                                crtdiscountFiled.toFixed(2),
                                              SGST: sgst.toFixed(2),
                                              CGST: cgst.toFixed(2),
                                              IGST: igst.toFixed(2),
                                              tax_amt: taxAmount.toFixed(2),
                                              total_amt: finalAmount.toFixed(2),
                                            };
                                          }
                                          return r;
                                        });

                                      // Recalculate subtotal and total
                                      const totalAmount =
                                        updatedProducts.reduce(
                                          (acc, row) =>
                                            acc +
                                            (parseFloat(row.total_amt) || 0),
                                          0
                                        );
                                      const discountValue =
                                        parseFloat(prevFormData.discount) || 0;
                                      const packingPercentage =
                                        parseFloat(
                                          prevFormData.packing_percentage
                                        ) || 0;

                                      const discountAmount =
                                        discountType === "Discount %"
                                          ? (
                                              (totalAmount * discountValue) /
                                              100
                                            ).toFixed(2)
                                          : discountValue.toFixed(2);
                                      const discountedSubtotal =
                                        discountType === "Discount %"
                                          ? (
                                              totalAmount -
                                              (totalAmount * discountValue) /
                                                100
                                            ).toFixed(2)
                                          : (
                                              totalAmount - discountValue
                                            ).toFixed(2);
                                      const packingAmount =
                                        calculatePackingAmount(
                                          totalAmount,
                                          discountValue,
                                          discountType,
                                          packingPercentage
                                        );
                                      const newTotal = (
                                        parseFloat(discountedSubtotal) +
                                        parseFloat(packingAmount)
                                      ).toFixed(2);

                                      return {
                                        ...prevFormData,
                                        product: updatedProducts,
                                        subtotal: totalAmount.toFixed(2),
                                        discount_amount: discountAmount,
                                        packing_amount: packingAmount,
                                        total: newTotal,
                                      };
                                    });
                                  }}
                                  onKeyDown={(e) => handleKeyPress(e, index)}
                                  autoFocus={
                                    index === formData.product.length - 1
                                  }
                                />
                              </div>
                            </td>
                            <td>
                              <TextInputForm
                                placeholder={"qty"}
                                name="qty"
                                value={row.qty}
                                onChange={(e) => handleChange(e, "qty", index)}
                                onKeyDown={(e) => handleKeyPress(e, index)}
                              />
                            </td>
                            <td>
                              <DropDownUI
                                optionlist={UnitData.map((user) => ({
                                  value: user.unit_id,
                                  label: user.unit_name,
                                }))}
                                placeholder="Unit"
                                name="unit"
                                value={row.unit}
                                onChange={(updatedFormData) =>
                                  setFormData({
                                    ...formData,
                                    product: formData.product.map((r, i) =>
                                      i === index
                                        ? { ...r, unit: updatedFormData.unit }
                                        : r
                                    ),
                                  })
                                }
                                onKeyDown={(e) => handleKeyPress(e, index)}
                              />
                            </td>
                            <td>
                              <TextInputForm
                                placeholder={"price"}
                                name="price_unit"
                                value={row.price_unit}
                                onChange={(e) =>
                                  handleChange(e, "price_unit", index)
                                }
                                onKeyDown={(e) => handleKeyPress(e, index)}
                              />
                            </td>
                            <td>
                              <TextInputForm
                                placeholder={"amt"}
                                name="total_amt"
                                value={row.total_amt}
                                onChange={(e) =>
                                  handleChange(e, "total_amt", index)
                                }
                                onKeyDown={(e) => handleKeyPress(e, index)}
                              />
                            </td>
                            <td>
                              <Delete
                                onClick={() => handleDeleteRow(index)}
                                label={<MdDeleteForever />}
                              />
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </Table>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <div className="my-3">
          <Container>
            <Row>
              <Col lg="5"></Col>
              <Col lg="7">
                <div className="inside my-3">
                  <Table>
                    <tr>
                      <td>Sub Total</td>
                      <td></td>
                      <td className="w-25">
                        <TextInputForm
                          placeholder={"SubTotal"}
                          name="subtotal"
                          value={formData.subtotal}
                          readOnly
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>Discount</td>
                      <td>
                        <DropDownUI
                          optionlist={discountOptions}
                          placeholder="Discount Type"
                          name="discount_type"
                          value={discountType}
                          onChange={(updatedValue) => {
                            setDiscountType(updatedValue.discount_type);
                            setFormData((prevData) => ({
                              ...prevData,
                              discount_type: updatedValue.discount_type,
                            }));
                            const totalAmount = formData.product.reduce(
                              (acc, row) =>
                                acc + (parseFloat(row.total_amt) || 0),
                              0
                            );
                            const discountValue =
                              parseFloat(formData.discount) || 0;
                            const packingPercentage =
                              parseFloat(formData.packing_percentage) || 0;

                            const discountAmount =
                              updatedValue.discount_type === "Discount %"
                                ? ((totalAmount * discountValue) / 100).toFixed(
                                    2
                                  )
                                : discountValue.toFixed(2);
                            const discountedSubtotal =
                              updatedValue.discount_type === "Discount %"
                                ? (
                                    totalAmount -
                                    (totalAmount * discountValue) / 100
                                  ).toFixed(2)
                                : (totalAmount - discountValue).toFixed(2);
                            const packingAmount = calculatePackingAmount(
                              totalAmount,
                              discountValue,
                              discountType,
                              packingPercentage
                            );
                            const newTotal = (
                              parseFloat(discountedSubtotal) +
                              parseFloat(packingAmount)
                            ).toFixed(2);

                            setFormData((prevData) => ({
                              ...prevData,
                              discount_amount: discountAmount,
                              packing_amount: packingAmount,
                              total: newTotal,
                            }));
                          }}
                        />
                      </td>
                      <td className="w-25">
                        <TextInputForm
                          placeholder={
                            discountType === "Discount %"
                              ? "Discount %"
                              : "Discount Amount"
                          }
                          name="discount"
                          value={formData.discount}
                          onChange={handleDiscountChange}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>Discount Amount</td>
                      <td></td>
                      <td className="w-25">
                        <TextInputForm
                          placeholder={"Discount Amount"}
                          name="discount_amount"
                          value={formData.discount_amount}
                          readOnly
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>Packing Percentage</td>
                      <td></td>
                      <td className="w-25">
                        <TextInputForm
                          placeholder={"Packing Percentage"}
                          name="packing_percentage"
                          value={formData.packing_percentage}
                          onChange={(e) =>
                            handleChange(e, "packing_percentage")
                          }
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>Packing Amount</td>
                      <td></td>
                      <td className="w-25">
                        <TextInputForm
                          placeholder={"Packing Amount"}
                          name="packing_amount"
                          value={formData.packing_amount}
                          readOnly
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>Total</td>
                      <td></td>
                      <td className="w-25">
                        <TextInputForm
                          placeholder={"Total"}
                          name="total"
                          value={formData.total}
                          readOnly
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>Remark</td>
                      <td></td>
                      <td className="w-25">
                        <TextInputForm
                          placeholder="Remarks"
                          name="remark"
                          value={formData.remark}
                          onChange={(e) => {
                            handleRemarkChange(e, "remark");
                          }}
                          className="m-3"
                        />
                      </td>
                    </tr>
                  </Table>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
      <div className="main stick-bottom">
        <div className="w-50 ms-auto">
          <Container>
            <Row>
              <Col lg="12">
                <div className="text-center">
                  {type === "edit" ? (
                    <>
                      <ToastContainer
                        position="bottom-center"
                        autoClose={3000}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                        theme="light"
                      />
                      <span className="mx-2">
                        <ClickButton
                          label={<>Update</>}
                          onClick={handleUpdateSubmit}
                        />
                      </span>
                      <span className="mx-2">
                        <ClickButton
                          label={<>Cancel</>}
                          onClick={() => navigate("/console/sales/estimation")}
                        />
                      </span>
                    </>
                  ) : (
                    <>
                      <ToastContainer
                        position="bottom-center"
                        autoClose={3000}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                        theme="light"
                      />
                      <span className="mx-2">
                        <ClickButton
                          label={<>Submit</>}
                          onClick={handleSubmit}
                        />
                      </span>
                      <span className="mx-2">
                        <ClickButton
                          label={<>Cancel</>}
                          onClick={() => navigate("/console/sales/estimation")}
                        />
                      </span>
                    </>
                  )}
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </>
  );
};

export default EstimationEntry;
